import { getMenuList } from '@/api/api'

const initState = () => {
  return {
    code: 0,
    menuList: [
      {
        id: 1,
        name: "首页",
        path: "/",
        children: []
      },
      {
        id: 2,
        name: "新闻动态",
        path: "/news_information",
        bg: 'news_information.png',
        children: [
          {
            id: 10,
            name: "新闻信息",
            path: "/news_information/message",
            children: null
          },
          {
            id: 11,
            name: "通知公告",
            path: "/news_information/notice",
            children: null
          }
        ]
      },
      {
        id: 3,
        name: "公益项目",
        path: "/public_project",
        bg: 'public_pro.png',
        children: [
          {
            id: 12,
            name: "专项基金",
            path: "/public_project/special",
            bg: require("../../assets/img/zhuanxiang_bg_1.png"),
            children: null
          },
          {
            id: 13,
            name: "国内项目",
            path: "/public_project/home",
            bg: require("../../assets/img/guonei_bg.png"),
            children: null
          },
          {
            id: 14,
            name: "国际项目",
            path: "/public_project/international",
            bg: require("../../assets/img/guoji_bg.png"),
            children: null
          }
        ]
      },
      // {
      //   id: 4,
      //   name: "历史沿革",
      //   path: "/history",
      //   bg: 'history_bg.png',
      //   children: [
      //     {
      //       id: 15,
      //       name: "历届董事会介绍",
      //       path: "/history/introduce",
      //       children: null
      //     },
      //     {
      //       id: 16,
      //       name: "历年重大项目",
      //       path: "/history/major_pro",
      //       children: null
      //     }
      //   ]
      // },
      {
        id: 5,
        name: "信息公示",
        path: "/public_info",
        bg: 'information_public.png',
        children: [
          {
            id: 17,
            name: "年度工作报告",
            path: "/public_info/year_report",
            children: null
          },
          {
            id: 18,
            name: "财务信息审计报告",
            path: "/public_info/finance_report",
            children: null
          },
          {
            id: 19,
            name: "专项信息审核报告",
            path: "/public_info/special_report",
            children: null
          },
          {
            id: 20,
            name: "规章制度",
            path: "/public_info/rules",
            children: null
          },
          // {
          //   id: 21,
          //   name: "项目披露",
          //   path: "/public_info/pro_disclosure",
          //   children: null
          // },
          {
            id: 31,
            name: "其他公示信息",
            path: "/public_info/other_info",
            children: null
          }
        ]
      },
      {
        id: 9,
        name: "项目入口",
        path: "/pro_inlet",
        children: [
          {
            id: 901,
            name: "项目申请",
            path: "https://project.cimf.org.cn/aided/login",
            children: null
          },
          {
            id: 902,
            name: "专家评审",
            path: "https://project.cimf.org.cn/expert/login",
            children: null
          },
          {
            id: 903,
            name: "志愿者登录",
            path: "https://project.cimf.org.cn/volunt/login",
            children: null
          }
        ]
      },
      {
        id: 6,
        name: "下载中心",
        path: "/download",
        bg: 'rule_bg.png',
        children: []
      },
      // {
      //   id: 7,
      //   name: "党群工作",
      //   bg: 'party_bg.png',
      //   children: [],
      //   path: "/party_work"
      // },
      {
        id: 8,
        name: "关于我们",
        path: "/about_us",
        bg: 'about_us.png',
        children: [
          {
            id: 23,
            name: "基金会简介",
            path: "/about_us/introduce",
            children: null
          },
          {
            id: 24,
            name: "基金会章程",
            path: "/about_us/rules",
            children: null
          },
          {
            id: 26,
            name: "本届理事会",
            path: "/about_us/council",
            children: null
          },
          // {
          //   id: 28,
          //   name: "往届理事会",
          //   path: "/about_us/history_introduce",
          //   children: null
          // },
          {
            id: 25,
            name: "组织结构",
            path: "/about_us/organization",
            children: null
          },
          {
            id: 27,
            name: "办事机构",
            path: "/about_us/office_structure",
            children: null
          },
          // {
          //   id: 28,
          //   name: "办公人员",
          //   path: "/about_us/office_staff",
          //   children: null
          // },
          {
            id: 29,
            name: "账户信息",
            path: "/about_us/account_information",
            children: null
          },
          {
            id: 30,
            name: "联系我们",
            path: "/about_us/contact_us",
            children: null
          }
        ]
      }
    ],
    menuName: "首页"
  }
}
export default {
  state: initState(),
  mutations: {
    setMenu: (state, data) => {
      state.menuList = data
    },
    setCode: (state, code) => {
      state.code = code
    },
    setMenuName: (state, name) => {
      state.menuName = name
    },
  },

  actions: {
    GET_MENU_LIST ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getMenuList()
          .then(res => {
            if (res.code == 200) {
              commit("setMenu", res.data)
              resolve()
            } else {
              commit("setCode", res.code)
              reject()
            }
          })
          .catch()
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js